module.exports = __webpack_public_path__ + "media/images/demo/m_site_template/29X28QR0-d1cb7a713fe0f5dce219b7131c8741df.png";